import { useEffect, useState } from 'react'
import {  Image, Button, Row, Col,Breadcrumb  } from "react-bootstrap";
import { useNavigate} from "react-router-dom";
import {
  FaqSearch,
  KnowledgeBase,
  MostRecent,
  KnowledgeTitle,
  KnowledgeSmallText,
  SolutionTabSection,
  UserGuideTitle,
  UserGuideGroup,
  UserGuideBox,
  Title,
  UserGuideList,
  UserGuideItem,
  UserGuideIcon,
  UserGuideButton,
  UserGuideWrapper,
  UserGuideSolution,
} from './FaqStyle';
import DocumentIcon from '../../assests/images/document-text.svg';
import CustomSearch from '../../components/common/customSearch';
import { useDispatch,useSelector } from 'react-redux';
import { faqHelpsHandler } from '../../redux/slices/faq/faqHelps-slice';
import { faqArticlesHandler } from '../../redux/slices/faq/faqArticles-slice';
import { faqUserGuideHandler } from '../../redux/slices/faq/faqUserGuide-slice';
import { faqTopRatedAwardsHandler } from '../../redux/slices/faq/faqTopRatedAwards-slice';
import { faqNonprofitHandler } from '../../redux/slices/nonProfit/nonprofitFaq-slice';

const FaqSolution = () => {
    const [searchValue, setSearchValue]= useState<string>('')
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const faqUserGuideList = useSelector((state:any) => state?.faqUserGuide?.data)
    const faqTopRatedAwardsList = useSelector((state:any) => state?.faqTopRatedAwards?.data)
    const nonprofitFaqSliceList = useSelector((state:any) => state?.faqNonprofit?.data)
  
    useEffect(() =>{
      dispatch(faqHelpsHandler());
      dispatch(faqArticlesHandler());
      dispatch(faqUserGuideHandler());
      dispatch(faqTopRatedAwardsHandler());
      dispatch(faqNonprofitHandler());
    },[])
  return (
  <>
   <FaqSearch>
        <CustomSearch 
            onSubmit={()=>{}}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            placeholder="Search GreatNonprofits Support Center..."
        />
   </FaqSearch>
    <SolutionTabSection>
      <KnowledgeBase>
        <MostRecent>            
            <Breadcrumb>
                <Breadcrumb.Item active> Solution</Breadcrumb.Item>
            </Breadcrumb>

            <KnowledgeTitle>Knowledge base</KnowledgeTitle>
            <KnowledgeSmallText>Explore for quick answers and how-to guides.</KnowledgeSmallText>
            <UserGuideSolution>
              <UserGuideWrapper>
                <UserGuideTitle>USER GUIDE</UserGuideTitle>
                  <Row>
                    <Col sm={12}>
                      <UserGuideGroup className='user-guide-group-box'>
                        {faqUserGuideList?.data?.map((guide:any, index:number) =>(
                          <UserGuideBox className='user-guide-box' key={index+1}>
                            <Title>{guide?.faqHeaderName}</Title>
                            <UserGuideList>
                              {guide?.questionList?.slice(0,4)?.map((faq:any, index:number) => (
                                <UserGuideItem key={index+1}>
                                  <UserGuideIcon><Image src={DocumentIcon}/></UserGuideIcon>
                                  {faq.question}
                                </UserGuideItem>
                              ))}
                            </UserGuideList>
                              {guide?.questionList?.length > 1 && 
                              <UserGuideButton>
                                <Button  className="btn-outline-success-blue view-all-article" 
                                  onClick={() => navigate('/faq-list',{state:{faqType:'User Guide', questionType:guide.faqHeaderName }})}>
                                  {`See All ${guide?.questionList?.length} Articles`}
                                </Button></UserGuideButton>
                              }
                          </UserGuideBox>
                        ))}
                      </UserGuideGroup>
                    </Col>
                </Row>
              </UserGuideWrapper>
                     
              <UserGuideWrapper>
                  <UserGuideTitle className='light-blue-title'>NONPROFIT GUIDE</UserGuideTitle>
                  <Row>                        
                    <Col sm={12}>
                      <UserGuideGroup className='user-guide-group-box'>
                        {faqUserGuideList?.data?.map((guide:any, index:number) =>(
                          <UserGuideBox key={index+1}>
                            <Title>{guide?.faqHeaderName}</Title>
                              <UserGuideList>
                                {guide?.questionList?.slice(0,4)?.map((faq:any, index:number) => (
                                  <UserGuideItem key={index+1}>
                                    <UserGuideIcon><Image src={DocumentIcon}/></UserGuideIcon>
                                    {faq.question}
                                  </UserGuideItem>
                                ))}
                              </UserGuideList>
                                {guide?.questionList?.length > 1 && 
                                <UserGuideButton><Button className="btn-outline-success-blue" onClick={() => navigate('/faq-list',{state:{faqType:'Nonprofit Guide', questionType:guide.faqHeaderName }})}> {`See All ${guide?.questionList?.length} Articles`}</Button></UserGuideButton>
                                }
                          </UserGuideBox>
                          ))}
                      </UserGuideGroup>
                    </Col>                       
                  </Row>
              </UserGuideWrapper>

                <UserGuideWrapper className='user-guide-wrapper'>
                    <UserGuideTitle>GREATNONPROFITS TOP-RATED AWARDS</UserGuideTitle>
                    <Row>
                        <Col sm={12}>
                          <UserGuideGroup className='user-guide-group'>
                            <UserGuideBox className='user-guide-box'>
                                <Title>Top-Rated Awards</Title>
                                  <UserGuideList>
                                    {faqTopRatedAwardsList?.data?.map((award:any, index:number) => (
                                      <UserGuideItem key={index+1}>
                                        <UserGuideIcon><Image src={DocumentIcon}/></UserGuideIcon>
                                        {award.question}
                                      </UserGuideItem>
                                    ))}
                                    </UserGuideList>
                              </UserGuideBox>
                          </UserGuideGroup>
                        </Col>
                    </Row>
                </UserGuideWrapper>

                <UserGuideWrapper>
                    <UserGuideTitle>GREATNONPROFITS FUNDRAISERS</UserGuideTitle>
                    
                    <Row>                         
                      <Col sm={12}>
                        <UserGuideGroup className='user-guide-group-box'>
                        {faqUserGuideList?.data?.map((guide:any, index:number) =>(
                            <UserGuideBox key={index+1}>
                              <Title>{guide?.faqHeaderName}</Title>
                              <UserGuideList>
                                {guide?.questionList?.slice(0,4)?.map((faq:any, index:number) => (
                                  <UserGuideItem key={index+1}>
                                    <UserGuideIcon><Image src={DocumentIcon}/></UserGuideIcon>
                                    {faq.question}
                                  </UserGuideItem>
                                ))}
                              </UserGuideList>
                              {guide?.questionList?.length > 1 && 
                              <UserGuideButton>
                                <Button className="btn-outline-success-blue"  onClick={() => navigate('/faq-list',{state:{faqType:'Greatnonprofits Fundraisers', questionType:guide.faqHeaderName }})}> {`See All ${guide?.questionList?.length} Articles`}</Button></UserGuideButton>}
                            </UserGuideBox>
                            ))}
                        </UserGuideGroup>
                      </Col>
                    </Row>
                </UserGuideWrapper>

                <UserGuideWrapper>
                    <UserGuideTitle>GREATNONPROFITS</UserGuideTitle>
                    <Row>
                      <Col sm={12}>
                        <UserGuideGroup className='user-guide-group-box'>
                          {nonprofitFaqSliceList?.data?.map((faq:any, index:number) => (
                            <UserGuideBox key={index+1}>
                              <Title>{faq.faqHeaderName}</Title>
                                <UserGuideList>
                                  {
                                    faq?.questionList?.map((questions:any, index:number) => (
                                    <UserGuideItem key={index+1}>
                                      <UserGuideIcon><Image src={DocumentIcon}/></UserGuideIcon>
                                        {questions.question}
                                    </UserGuideItem>
                                    ))
                                  }
                                  </UserGuideList>
                                  {faq.questionList.length > 2 &&
                                    <UserGuideButton><Button className="btn-outline-success-blue"  onClick={() => navigate('/faq-list',{state:{faqType:'Greatnonprofit', questionType:faq.faqHeaderName }})}>{`See All ${faq.questionList.length} Articles`}</Button></UserGuideButton>
                                  }
                            </UserGuideBox>
                          ))}
                        </UserGuideGroup>
                      </Col>
                    </Row>
                </UserGuideWrapper>
            </UserGuideSolution>
        </MostRecent>
      </KnowledgeBase>
    </SolutionTabSection>
  </>
  )
}

export default FaqSolution
